import React from 'react';
import Spinner from 'react-bootstrap/Spinner'
import classes from './index.module.scss';

const Loading = () => {
  return (
    <div className={classes.Custom_Spinner_Wrap}>
      <Spinner className={classes.Custom_Spinner} animation="border" variant="dark" role="status" />
    </div>
  )
}

export default Loading;